import type { Route } from '@metro/routing'
import type { OfflineRouteSearch } from './offlineRouteSearch'

/**
 * Where the offline route search runs. The adapter awaits it, so a runner
 * may move the search off the main thread (`createWorkerOfflineSearchRunner`)
 * — a search freezes the page for its whole duration, and offline is when a
 * rider is underground. Rejects with `RoutingError` like the search throws.
 */
export interface OfflineSearchRunner {
  run(fromStationId: string, toStationId: string): Promise<Route[]>
  dispose(): void
}

/** The search on the calling thread — tests, prerender, no Worker support. */
export function inThreadOfflineSearchRunner(search: OfflineRouteSearch): OfflineSearchRunner {
  return {
    run: (from, to) => new Promise((resolve) => resolve(search(from, to))),
    dispose: () => {},
  }
}
